import { render } from "./legislative.vue?vue&type=template&id=7d12c8fd&scoped=true"
import script from "./legislative.vue?vue&type=script&lang=js"
export * from "./legislative.vue?vue&type=script&lang=js"

import "./legislative.vue?vue&type=style&index=0&id=7d12c8fd&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d12c8fd"]])

export default __exports__